import React from 'react';
import styles from './styles.module.scss';
import moment from 'moment';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import FastagMapComponent from './fastagMapComponent';

const FastagDetails = ({ vehicleData }) => {
  const sortedData = vehicleData
    ? [...vehicleData].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
      )
    : [];

  const formatDateTime = (dateString) => {
    const paresdDate = moment(dateString).format('DD MMM YYYY HH:mm A');
    const [datePart, timePart] = paresdDate.split(/ (?=\d{1,2}:\d{2})/);
    return [datePart, timePart];
  };

  return (
    <div className={styles.trackingDetailsSection}>
      <div className={styles.trackingContent}>
        <div className={styles.trackingLeft}>
          <h2 className={styles.trackingTitle}>Tracking Details</h2>
          <div className={styles.trackingTableContainer}>
            <table className={styles.trackingTable}>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Location</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody className={styles.trackingTableBody}>
                {sortedData.map((item) => (
                  <tr key={item._id}>
                    <td>
                      <div className={styles.dateTime}>
                        {formatDateTime(item.createdAt)[0]}
                      </div>
                      <div className={styles.dateTime}>
                        {formatDateTime(item.createdAt)[1]}
                      </div>
                    </td>
                    <td>
                      <div className={styles.locationInfo}>
                        <div className={styles.locationPin}>
                          <PanoramaFishEyeIcon className={styles.pinIcon} />
                          <div className={styles.pinLine}></div>
                        </div>
                        <span className={styles.locationText}>
                          {item.address}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className={styles.notes}></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        
        <div className={styles.trackingRight}>
          <h2 className={styles.trackingTitle}>Map View</h2>
          <div>
            <FastagMapComponent vehicleData={vehicleData} />
          </div> 
        </div>
      </div>
    </div>
  );
};

export default FastagDetails;
